var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownTrendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_963_2375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48811 7.66036L5.48811 8.75305L8.76734 8.75344L8.76734 5.47459L7.67426 5.47498L7.67388 6.88721L4.76171 3.97504L3.98894 4.7478L6.90111 7.65997L5.48811 7.66036Z",
    fill: "#EA3024"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8073 10.8071C13.1548 8.45964 13.1548 4.65432 10.8073 2.30686C8.45985 -0.0405992 4.65452 -0.0405994 2.30706 2.30686C-0.040394 4.65431 -0.0403942 8.45964 2.30706 10.8071C4.65452 13.1546 8.45985 13.1546 10.8073 10.8071ZM10.0347 10.0345C10.9569 9.11217 11.4751 7.86128 11.4751 6.55698C11.4751 5.25267 10.9569 4.00179 10.0347 3.07951C9.11237 2.15723 7.86149 1.63909 6.55718 1.63909C5.25288 1.63909 4.002 2.15722 3.07971 3.07951C2.15743 4.00179 1.6393 5.25267 1.6393 6.55698C1.6393 7.86128 2.15743 9.11217 3.07971 10.0345C4.002 10.9567 5.25288 11.4749 6.55718 11.4749C7.86149 11.4749 9.11237 10.9567 10.0347 10.0345Z",
    fill: "#EA3024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_963_2375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.1143,
    height: 13.1143,
    fill: "white",
    transform: "translate(13.1143) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownTrendIcon);
export default __webpack_public_path__ + "static/media/arrow_down_trend_icon.588b2163ae63cfb3ce2bcf3086516c17.svg";
export { ForwardRef as ReactComponent };